module.exports = __webpack_public_path__ + "static/media/02.26b04c1d.jpg";